export const TiposResponsaveisEnum = Object.freeze({
  ADMINISTRADOR: 1,
  CONTABIL: 2,
  EXECUTIVO: 3,
  GESTAO: 4,
  OPERACIONAL: 5,
});
